(() => {
  if (window.ceikaTemplateRequestLoaded) return;
  window.ceikaTemplateRequestLoaded = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-template-request]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    const root = link.closest('.ceika-product-pilot');
    const kit = root?.querySelector('.ceika-build-selection')?.textContent.trim();
    url.searchParams.set('vehicle', link.dataset.templateVehicle || '');
    url.searchParams.set('request', link.dataset.templateMessage || '');
    if (kit) url.searchParams.set('kit', kit);
    const wheel = root?.querySelector('input[id^="ceika-wheel-"]')?.value;
    if (wheel) url.searchParams.set('wheel', wheel);
    url.searchParams.set('product', link.dataset.templateProduct || '');
    // Only carry the explicitly active unpublished preview, never force a theme.
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
    link.href = url.href;
  });
  function prefill() {
    const params = new URLSearchParams(location.search);
    if (params.get('ceika_template') !== '1') return;
    const field = document.querySelector('textarea[name="contact[body]"]');
    if (!field) return;
    const read = key => (params.get(key) || '').slice(0, 1000);
    const year = /^\d{4}$/.test(read('year')) && Number(read('year')) >= 1886 && Number(read('year')) <= new Date().getFullYear() ? read('year') : '';
    const vehicle = read('vehicle');
    const carLabel = year && !vehicle.startsWith(year + ' ') ? `${year} ${vehicle}`.trim() : vehicle;
    const lines = [read('request'), carLabel, read('kit')].filter(Boolean);
    const country = /^[A-Z]{2}$/.test(read('country')) ? read('country') : '';
    const currency = /^[A-Z]{3}$/.test(read('currency')) ? read('currency') : '';
    if(country)lines.push(`Delivery country: ${country}${currency ? ' · ' + currency : ''}`);
    const product = read('product');
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-zA-Z0-9_-]+$/.test(product)) lines.push(product);
    const car = field.form.querySelector('input[name="contact[Card Model & Year]"]');
    const wheel = field.form.querySelector('input[name="contact[Wheel Size (For Big Brakes inquiry)]"]');
    const inquiry = field.form.querySelector('select[name="contact[Your Inquiry]"]');
    const productType = field.form.querySelector('select[name="contact[Product Type]"]');
    if (car && !car.value.trim()) car.value = carLabel;
    if (wheel && !wheel.value.trim() && /^\d{2}$/.test(read('wheel'))) wheel.value = read('wheel') + ' inches';
    if (inquiry && !inquiry.value) {
      const general = [...inquiry.options].find(option => option.value === (read('inquiry') || 'General & Ordering'));
      if (general) inquiry.value = general.value;
    }
    if (productType && !productType.value) {
      const kit = (read('family') + ' ' + read('kit')).toLowerCase();
      const aliases = [
        [/\b(?:big\s*brake\s*kits?|brakes?)\b/, 'Big Brake Kit'],
        [/\bair[\s_-]*ride\b/, 'Air Ride'],
        [/\bcoilovers?\b/, 'Coilovers'],
        [/\b(?:forged\s*wheels?|wheels?)\b/, 'Forged Wheels'],
        [/\boem\s*rotors?\b/, 'OEM Rotors']
      ];
      const match = aliases.find(([pattern]) => pattern.test(kit));
      if (match && [...productType.options].some(option => option.value === match[1])) productType.value = match[1];
    }
    const source=/^\/(?!\/)[^\r\n]*$/.test(read('source')) ? read('source') : '';
    const vehicleId=/^[a-zA-Z0-9_-]{1,100}$/.test(read('vehicle_id')) ? read('vehicle_id') : '';
    const details = {'Vehicle reference': vehicleId, 'Model year': year, 'Delivery country': country, 'Currency': currency, 'Enquiry source': source};
    Object.entries(details).forEach(([name,value]) => {
      if(!value || field.form.querySelector(`input[name="contact[${name}]"]`))return;
      const input=document.createElement('input');input.type='hidden';input.name=`contact[${name}]`;input.value=value;field.form.append(input);
    });
    if (!field.value.trim()) {
      field.value = lines.join('\n\n');
      field.dispatchEvent(new Event('input', {bubbles: true}));
      field.dispatchEvent(new Event('change', {bubbles: true}));
      field.form.scrollIntoView({block: 'start'});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefill, {once: true});
  else prefill();
})();
